import {IDatepickerConfig} from "angular-ui-bootstrap";
import {ui} from "angular";

export const DefaultDateFormat = "dd-MM-yyyy";

export const DatePickerDefaults: IDatepickerConfig = {
    dateDisabled: disableWeekends
};

export function disableWeekends({date, mode}: ui.bootstrap.IDatepickerCellArgs): boolean {
    if (mode !== "day") {
        return false;
    }

    const day = date.getDay();
    return day === 0 || day === 6;
}
